export const colors = {
    white: '#fff',
    primary: '#00adef',
    secondary: '#5271FF',
    tertiary: '#022179',
    gray: '#d1d5db',
    grayligth: '#f3f4f6',
    graydark: '#4b5563',
    accent: '#fbcd77'
};